import type { Task, DaySchedule } from '../../types';

export type { Task, DaySchedule };

export function getWeekKey(): string {
  const now = new Date();
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const days = Math.floor((now.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000));
  const weekNum = Math.ceil((days + startOfYear.getDay() + 1) / 7);
  return `${now.getFullYear()}-W${weekNum}`;
}

export function getWeekOfMonth(): number {
  const now = new Date();
  return Math.min(4, Math.ceil(now.getDate() / 7));
}

export function getCurrentDayIndex(): number {
  const jsDay = new Date().getDay();
  if (jsDay === 0) return -1;
  return jsDay - 1;
}

export function getDayOfWeekName(): string {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[new Date().getDay()];
}

/** Get the calendar date (YYYY-MM-DD) for a given day index (0=Mon, 5=Sat) in the current week */
export function getDateForDayIndex(dayIndex: number): string {
  const now = new Date();
  const jsDay = now.getDay(); // 0=Sun, 1=Mon, ...
  const mondayOffset = jsDay === 0 ? -6 : 1 - jsDay;
  const monday = new Date(now);
  monday.setDate(now.getDate() + mondayOffset);
  const target = new Date(monday);
  target.setDate(monday.getDate() + dayIndex);
  return target.toISOString().split('T')[0];
}

export const scheduleData: DaySchedule[] = [
  {
    day: 'Monday',
    theme: 'BEDROOM DAY',
    color: '#B84A42',
    lightColor: '#FAEAE9',
    tasks: [
      { id: 'mon-0', label: 'Change sheets' },
      { id: 'mon-1', label: 'Clean fan' },
      { id: 'mon-2', label: 'Sweep/vacuum floors' },
      { id: 'mon-3', label: 'Declutter 10 mins' },
    ],
  },
  {
    day: 'Tuesday',
    theme: 'BATHROOM DAY',
    color: '#3B9FC4',
    lightColor: '#E6F3F9',
    tasks: [
      { id: 'tue-0', label: 'Clean shower & toilet' },
      { id: 'tue-1', label: 'Clean sink, counter' },
      { id: 'tue-2', label: 'Sweep & mop floors' },
      { id: 'tue-3', label: 'Clean mirror' },
    ],
  },
  {
    day: 'Wednesday',
    theme: 'KITCHEN DAY',
    color: '#C8903E',
    lightColor: '#FBF1E4',
    tasks: [
      { id: 'wed-0', label: 'Clean refrigerator' },
      { id: 'wed-1', label: 'Clean counters' },
      { id: 'wed-2', label: 'Clean table & chairs' },
      { id: 'wed-3', label: 'Sweep & mop floors' },
    ],
  },
  {
    day: 'Thursday',
    theme: 'LIVING ROOM DAY',
    color: '#8B5A9E',
    lightColor: '#F1EBF6',
    tasks: [
      { id: 'thu-0', label: 'Dust & polish furniture' },
      { id: 'thu-1', label: 'Clean TV' },
      { id: 'thu-2', label: 'Clean fabrics' },
      { id: 'thu-3', label: 'Sweep/vacuum floors' },
    ],
  },
  {
    day: 'Friday',
    theme: 'ALTERNATE',
    color: '#5A9A4A',
    lightColor: '#EAF4E8',
    tasks: [
      { id: 'fri-0', label: 'All appliances', weekNum: 1 },
      { id: 'fri-1', label: 'Kitchen cabinets', weekNum: 2 },
      { id: 'fri-2', label: 'Windows & blinds', weekNum: 3 },
      { id: 'fri-3', label: 'Walls & baseboards', weekNum: 4 },
    ],
  },
  {
    day: 'Saturday',
    theme: 'OUTSIDE',
    color: '#C4568E',
    lightColor: '#FAEAF2',
    tasks: [
      { id: 'sat-0', label: 'Clean car' },
      { id: 'sat-1', label: 'Yard work' },
      { id: 'sat-2', label: 'Sort out the garage' },
      { id: 'sat-3', label: 'Weeding' },
    ],
  },
];
